var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.56835 13.5558C8.9812 12.609 12.5423 9.89799 12.5423 6.62467C12.5423 3.5641 10.0612 1.08301 7.00065 1.08301C3.94007 1.08301 1.45898 3.5641 1.45898 6.62467C1.45898 9.89799 5.0201 12.609 6.43295 13.5558C6.78003 13.7884 7.22127 13.7884 7.56835 13.5558ZM7.00065 8.37467C7.96715 8.37467 8.75065 7.59117 8.75065 6.62467C8.75065 5.65818 7.96715 4.87467 7.00065 4.87467C6.03415 4.87467 5.25065 5.65818 5.25065 6.62467C5.25065 7.59117 6.03415 8.37467 7.00065 8.37467Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationWhite);
export default __webpack_public_path__ + "static/media/location_white.d93ed3b1656ed670c48d7c0eb358bc3d.svg";
export { ForwardRef as ReactComponent };